// Distributors data for European map
export const distributorsData = {
  belgium: {
    name: "Belgie",
    nameEn: "Belgium",
    distributors: [
      {
        name: "Armurerie Foucart Michel",
        address: "Rue des Freres Gilbert 11, 7800 ATH",
        website: "https://armureriefoucart.be/"
      }
    ]
  },
  bulgaria: {
    name: "Bulharsko",
    nameEn: "Bulgaria",
    distributors: [
      {
        name: "Defence EOOD",
        address: "36 Vitosha Blvd., 1000 Sofia",
        website: "www.defence.bg"
      }
    ]
  },
  denmark: {
    name: "Dánsko",
    nameEn: "Denmark",
    distributors: [
      {
        name: "Zero Mike Armory",
        address: "Ny Kaervej 31, 9000 Aalborg",
        website: "www.zeromike.dk"
      }
    ]
  },
  finland: {
    name: "Finsko",
    nameEn: "Finland",
    distributors: [
      {
        name: "Aalto Group Oy",
        address: "Malminkartanontie 1, 00390 Helsinki",
        website: "viranomainen.fi"
      }
    ]
  },
  france: {
    name: "Francie",
    nameEn: "France",
    distributors: [
      {
        name: "BGM",
        address: "15 route de Meaux – RN377410 Claye-Souilly",
        website: "www.bgmwinfield.fr"
      }
    ]
  },
  netherlands: {
    name: "Holandsko",
    nameEn: "Netherlands",
    distributors: [
      {
        name: "Schietsportcentrum IDC",
        address: "Exaeten 5, 6095 PD Baexem",
        website: "https://www.schietsportcentrumidc.nl/"
      }
    ]
  },
  croatia: {
    name: "Chorvatsko",
    nameEn: "Croatia",
    distributors: [
      {
        name: "Bullet d.o.o.",
        address: "Gornji put 6, 10 090 Zagreb",
        website: "http://bullet.hr"
      }
    ]
  },
  lithuania: {
    name: "Litva",
    nameEn: "Lithuania",
    distributors: [
      {
        name: "Šūvio akademija",
        address: "S.Zukausko str. 35-20, LT-09129 Vilnius",
        website: "www.suvioakademija.lt"
      }
    ]
  },
  luxembourg: {
    name: "Lucembursko",
    nameEn: "Luxembourg",
    distributors: [
      {
        name: "BOLD ACTION B.V.",
        address: "Lindeweg 115, 3334 LA Zwijndrecht",
        website: "www.bold-action.com"
      }
    ]
  },
  hungary: {
    name: "Maďarsko",
    nameEn: "Hungary",
    distributors: [
      {
        name: "BRAVE BULLET KFT.",
        address: "9184 KUNSZIGET, FŐ ÚT 47/A",
        website: "www.bravebullet.hu"
      }
    ]
  },
  germany: {
    name: "Německo",
    nameEn: "Germany",
    distributors: [
      {
        name: "MoeWe-Waffen Frank Wegehenkel",
        address: "Birkenstr. 1a 65527 Waldems",
        website: "https://www.moewe-waffen.de"
      },
      {
        name: "Bayerwald Jagdcenter GmbH & Co. KG",
        address: "Theresienthaler Str. 25, 94227 Zwiesel",
        website: "www.bayerwald-jagdcenter.de"
      }
    ]
  },
  poland: {
    name: "Polsko",
    nameEn: "Poland",
    distributors: [
      {
        name: "Halinka ARMS",
        address: "ul. Łęcka 18, 32626 Jawiszowice",
        email: "halinka@halinka-arms.pl"
      },
      {
        name: "PackPartners Lech Kowalski",
        address: "ul. Polna 5b, 82-500 Rakowiec",
        website: "www.pociski.eu"
      },
      {
        name: "Double MISS Academy",
        address: "Mala 16, 95006 Bukowiec",
        website: "www.doublemissacademy.com"
      }
    ]
  },
  portugal: {
    name: "Portugalsko",
    nameEn: "Portugal",
    distributors: [
      {
        name: "Artilharia6",
        address: "Rua Joao Freitas Branco No3, 2820-377 Charneca Caparica",
        website: "www.artilharia6.com"
      }
    ]
  },
  austria: {
    name: "Rakousko",
    nameEn: "Austria",
    distributors: [
      {
        name: "Seidler KG",
        address: "Heiligenstaedter Strasse 67, A 1190 Vienna",
        website: "https://www.seidler-waffen.at/aktuelles.html"
      },
      {
        name: "LuckyDelta e.U.",
        address: "Hauptplatz 18/2/17, A-2320 Schwechat",
        website: "www.luckydelta.com"
      },
      {
        name: "Markus Königsberger – RangeIsClear",
        email: "info@rangeisclear.com"
      },
      {
        name: "Ammoworx Austria",
        address: "Kühberg 36, 5202 Neumarkt am wallersee",
        website: "https://ammoworx-austria.net/"
      }
    ]
  },
  greece: {
    name: "Řecko",
    nameEn: "Greece",
    distributors: [
      {
        name: "VK GUNS & ACCESORIES",
        address: "1st klm Serres-Thessaloniki",
        website: "www.vkguns.com"
      }
    ]
  },
  slovakia: {
    name: "Slovensko",
    nameEn: "Slovakia",
    distributors: [
      {
        name: "BLACKMARKET",
        address: "Pod Táborom 37, 08071 Prešov",
        website: "www.blackmarket.sk"
      },
      {
        name: "IMEX Trade",
        address: "Komárňanská 46, 947 01 Hurbanovo",
        website: "https://imextrade.sk/"
      },
      {
        name: "TIUS",
        address: "Platanova 3226/6, 010 07 Žilina",
        website: "http://www.tius.sk"
      }
    ]
  },
  slovenia: {
    name: "Slovinsko",
    nameEn: "Slovenia",
    distributors: [
      {
        name: "Cesar shop d.o.o.",
        address: "Poljska pot 11, 1000 Ljubljana",
        website: "www.cesar-shop.com"
      }
    ]
  },
  spain: {
    name: "Španělsko",
    nameEn: "Spain",
    distributors: [
      {
        name: "MHB EQUIPAMIENTO POLICIAL, S.L.",
        address: "C/ Agustina de Aragon, 66 CP35012 Las Palmas (Kanárské ostrovy)",
        website: "www.mhbcanarias.com"
      },
      {
        name: "Armeria TOPGUN",
        website: "www.topgun.es"
      },
      {
        name: "ARMERIA GABILONDO, S.A.",
        website: "www.gabilondosport.com/"
      }
    ]
  },
  sweden: {
    name: "Švédsko",
    nameEn: "Sweden",
    distributors: [
      {
        name: "Bisam Service AB",
        address: "Maringatan 13, 59173 Motala",
        website: "https://bisamkula.se/kulor/9mm"
      }
    ]
  },
  switzerland: {
    name: "Švýcarsko",
    nameEn: "Switzerland",
    distributors: [
      {
        name: "Indoor Swiss Shooting AG",
        address: "Bischofszellerstrasse 72a, 9200 Gossau SG",
        website: "http://www.indoorswiss.ch"
      }
    ]
  },
  ukraine: {
    name: "Ukrajina",
    nameEn: "Ukraine",
    distributors: [
      {
        name: "IBIS company",
        address: "20, S. Bandery Ave, 04655 Kiev",
        website: "www.ibis.net.ua"
      }
    ]
  },
  uk: {
    name: "Velká Británie",
    nameEn: "United Kingdom",
    distributors: [
      {
        name: "BulleUK Ltd Flecktarn",
        address: "PO Box 1520, West End GU24 9BF",
        website: "www.flecktarn.co.uk"
      }
    ]
  }
};
